// 9fbef606107a605d69c0edbcd8029e5d
import { FAVORITES_ACTION_PATTERN } from '../../../../../constants/reducer.constants';

const SET_FAVORITES = `${FAVORITES_ACTION_PATTERN}SET_FAVORITES`;
const SET_FAVORITES_STATE = `${FAVORITES_ACTION_PATTERN}SET_FAVORITES_STATE`;
const GET_FAVORITES_WISHLIST = `${FAVORITES_ACTION_PATTERN}FAVORITES_GET_AVAILABLE_WISHLISTS`;
const SET_FAVORITES_WISHLIST = `${FAVORITES_ACTION_PATTERN}FAVORITES_SET_AVAILABLE_WISHLISTS`;
const SET_ACTIVE_WISHLIST = `${FAVORITES_ACTION_PATTERN}SET_ACTIVE_WISHLIST`;
const LOAD_ACTIVE_FAVORITES_WISHLIST = `${FAVORITES_ACTION_PATTERN}LOAD_ACTIVE_FAVORITES_WISHLIST`;
const LOAD_ACTIVE_FAVORITES_WISHLIST_GUEST = `${FAVORITES_ACTION_PATTERN}LOAD_ACTIVE_FAVORITES_WISHLIST_GUEST`;
const CREATE_NEW_WISHLIST = `${FAVORITES_ACTION_PATTERN}CREATE_NEW_WISHLIST`;
const CREATE_NEW_WISHLIST_MOVE_ITEM = `${FAVORITES_ACTION_PATTERN}CREATE_NEW_WISHLIST_MOVE_ITEM`;
const CREATE_NEW_WISHLIST_ADD_ITEM = `${FAVORITES_ACTION_PATTERN}CREATE_NEW_WISHLIST_ADD_ITEM`;
const DELETE_WISHLIST = `${FAVORITES_ACTION_PATTERN}DELETE_WISHLIST`;
const DELETE_WISHLIST_OOS = `${FAVORITES_ACTION_PATTERN}DELETE_WISHLIST_OOS`;
const DELETE_WISHLIST_ITEM = `${FAVORITES_ACTION_PATTERN}DELETE_WISHLIST_ITEM`;
const DELETED_WISHLIST_ITEM = `${FAVORITES_ACTION_PATTERN}DELETED_WISHLIST_ITEM`;
const UPDATE_WISHLIST = `${FAVORITES_ACTION_PATTERN}UPDATE_WISHLIST`;
const UPDATE_WISHLIST_ITEM = `${FAVORITES_ACTION_PATTERN}UPDATE_WISHLIST_ITEM`;
const SEND_WISHLIST_EMAIL = `${FAVORITES_ACTION_PATTERN}SEND_WISHLIST_EMAIL`;
const FAVORITES_SET_IS_READ_ONLY_WISHLIST = `${FAVORITES_ACTION_PATTERN}FAVORITES_SET_IS_READ_ONLY_WISHLIST`;
const FAVORITES_SET_ACTIVE_WISHLIST = `${FAVORITES_ACTION_PATTERN}FAVORITES_SET_ACTIVE_WISHLIST`;
const FAVORITES_SET_LOADING = `${FAVORITES_ACTION_PATTERN}FAVORITES_SET_LOADING`;
const SET_FAVORITES_ERROR = `${FAVORITES_ACTION_PATTERN}SET_FAVORITES_ERROR`;
const REMOVE_FAVORITES_ERROR = `${FAVORITES_ACTION_PATTERN}REMOVE_FAVORITES_ERROR`;
const FAVORITES_SET_WISHLIST_SHARE_SUCCESS = `${FAVORITES_ACTION_PATTERN}FAVORITES_SET_WISHLIST_SHARE_SUCCESS`;
const FAVORITES_REPLACE_WISHLIST_ITEM = `${FAVORITES_ACTION_PATTERN}FAVORITES_REPLACE_WISHLIST_ITEM`;
const MAXIMUM_PRODUCT_ADDED_ERROR = `${FAVORITES_ACTION_PATTERN}MAXIMUM_PRODUCT_ADDED_ERROR`;
const RESET_MAXIMUM_PRODUCT_ADDED_ERROR = `${FAVORITES_ACTION_PATTERN}RESET_MAXIMUM_PRODUCT_ADDED_ERROR`;
const FAVORITES_SET_DEFAULT_WISHLIST = `${FAVORITES_ACTION_PATTERN}FAVORITES_SET_DEFAULT_WISHLIST`;
const GET_USER_FAVORITES = `${FAVORITES_ACTION_PATTERN}GET_USER_FAVORITES`;
const FAVORITES_SET_CLICKED_OOS_ITEM_ID = `${FAVORITES_ACTION_PATTERN}FAVORITES_SET_CLICKED_OOS_ITEM_ID`;
const FAVORITES_SET_DEFAULT_WISHLIST_ID = `${FAVORITES_ACTION_PATTERN}FAVORITES_SET_DEFAULT_WISHLIST_ID`;
const RESET_FAVORITES_REDUCER = `${FAVORITES_ACTION_PATTERN}RESET_FAVORITES_REDUCER`;
const SET_DELETE_FAV_ITEM_PROGRESS = `${FAVORITES_ACTION_PATTERN}SET_DELETE_FAV_ITEM_PROGRESS`;
const SET_PENDING_ADD_WISHLIST_PRODUCT = `${FAVORITES_ACTION_PATTERN}SET_PENDING_ADD_WISHLIST_PRODUCT`;
const SHOW_TOAST_MODAL = `${FAVORITES_ACTION_PATTERN}SHOW_TOAST_MODAL`;
const SET_SHOW_LOGIN_MODAL = `${FAVORITES_ACTION_PATTERN}SET_SHOW_LOGIN_MODAL`;
const SHOW_ADD_TO_FAVORITES_FLYOUT = `${FAVORITES_ACTION_PATTERN}SHOW_ADD_TO_FAVORITES_FLYOUT`;
const SET_PRESERVED_DEFAULT_WISHLIST = `${FAVORITES_ACTION_PATTERN}SET_PRESERVED_DEFAULT_WISHLIST`;
const CLEAR_PRESERVED_DEFAULT_WISHLIST = `${FAVORITES_ACTION_PATTERN}CLEAR_PRESERVED_DEFAULT_WISHLIST`;

const FAVORITES_CONSTANTS = {
  SET_FAVORITES,
  SET_FAVORITES_STATE,
  GET_FAVORITES_WISHLIST,
  SET_FAVORITES_WISHLIST,
  SET_ACTIVE_WISHLIST,
  LOAD_ACTIVE_FAVORITES_WISHLIST,
  LOAD_ACTIVE_FAVORITES_WISHLIST_GUEST,
  CREATE_NEW_WISHLIST,
  CREATE_NEW_WISHLIST_MOVE_ITEM,
  CREATE_NEW_WISHLIST_ADD_ITEM,
  DELETE_WISHLIST,
  DELETE_WISHLIST_OOS,
  DELETE_WISHLIST_ITEM,
  DELETED_WISHLIST_ITEM,
  UPDATE_WISHLIST,
  UPDATE_WISHLIST_ITEM,
  SEND_WISHLIST_EMAIL,
  FAVORITES_SET_IS_READ_ONLY_WISHLIST,
  FAVORITES_SET_ACTIVE_WISHLIST,
  FAVORITES_SET_LOADING,
  SET_FAVORITES_ERROR,
  REMOVE_FAVORITES_ERROR,
  FAVORITES_SET_WISHLIST_SHARE_SUCCESS,
  FAVORITES_REPLACE_WISHLIST_ITEM,
  MAXIMUM_PRODUCT_ADDED_ERROR,
  RESET_MAXIMUM_PRODUCT_ADDED_ERROR,
  FAVORITES_SET_DEFAULT_WISHLIST,
  GET_USER_FAVORITES,
  FAVORITES_SET_CLICKED_OOS_ITEM_ID,
  FAVORITES_SET_DEFAULT_WISHLIST_ID,
  RESET_FAVORITES_REDUCER,
  SET_DELETE_FAV_ITEM_PROGRESS,
  SET_PENDING_ADD_WISHLIST_PRODUCT,
  SHOW_TOAST_MODAL,
  SET_SHOW_LOGIN_MODAL,
  SHOW_ADD_TO_FAVORITES_FLYOUT,
  SET_PRESERVED_DEFAULT_WISHLIST,
  CLEAR_PRESERVED_DEFAULT_WISHLIST,
};

export const AVAILABILITY = {
  OK: 'OK',
  SOLDOUT: 'SOLDOUT',
  UNAVAILABLE: 'UNAVAILABLE',
  SUGGESTED: 'SUGGESTED', // REVIEW: we need it to control an state to favorite's item (favorites' page).
};

export const STATUS = {
  PURCHASED: 'PURCHASED',
  SUGGESTED: 'SUGGESTED',
};

export default FAVORITES_CONSTANTS;
